export default __webpack_public_path__ + "static/media/ogp-logo.bc777731.svg";